import { useLookupIP } from "@outschool/iplookup-client";
import { useSession } from "@outschool/ui-auth";

const EXCLUDED_STATES = ["AZ", "FL", "AR", "AL"];

export function useRequiresMembershipForEnrollment() {
  const { isLoggedIn, currentUser, isEsaSession } = useSession();
  const { ipInfo } = useLookupIP();

  const stateIsoCode =
    ipInfo?.country?.isoCode === "US"
      ? ipInfo?.subdivisions?.[0]?.isoCode
      : undefined;

  const isStateExcluded =
    stateIsoCode && EXCLUDED_STATES.includes(stateIsoCode);

  const currentUserRequiresMembershipForEnrollment =
    !!currentUser?.requiresMembershipForEnrollment;

  const requiresMembershipForEnrollment =
    (!isLoggedIn || currentUserRequiresMembershipForEnrollment) &&
    !isEsaSession &&
    !isStateExcluded;

  return {
    requiresMembershipForEnrollment,
  };
}

export function useShowCredits() {
  const { requiresMembershipForEnrollment } =
    useRequiresMembershipForEnrollment();
  const { currentUser } = useSession();
  return (
    requiresMembershipForEnrollment ||
    currentUser?.canPayWithSubscriptionCredits
  );
}
